import { Image } from "@heroui/react";
import clsx from "clsx";
import { APP_CLINIC } from "core/consts";
import { getStaticAsset } from "core/model/config";
import { AppType } from "core/types";
import { getRecareLogoWithNamePath } from "ds_legacy/components/RecareLogo";
import { Button } from "ds/ui";
import { useTranslations } from "translations";
import {
  getTokenErrorTitle,
  PasswordResetProps,
  useGetTokenErrorText,
} from "../PasswordResetPage";

export type TokenExpiredProps = Pick<
  PasswordResetProps,
  "isActivation" | "tokenInvalidReason"
> & { app: AppType; authRoute: string };

export default function TokenExpired({
  app,
  authRoute,
  isActivation,
  tokenInvalidReason,
}: TokenExpiredProps) {
  const translations = useTranslations();

  const tokenErrorDescription = useGetTokenErrorText({
    app,
    isActivation,
    tokenInvalidReason,
  });

  return (
    <div
      className={clsx(
        "flex min-h-screen w-full max-w-screen flex-col items-center justify-center bg-cover bg-center py-12",
        app === APP_CLINIC
          ? "bg-token-expired-sender"
          : "bg-token-expired-receiver",
      )}
    >
      <div className="flex w-[468px] flex-col items-center text-center">
        <Image
          alt="Recare logo"
          src={getStaticAsset(getRecareLogoWithNamePath("master"))}
          width={160}
        />
        <div className="mt-12 flex flex-col gap-y-8">
          <div className="flex flex-col gap-y-4">
            <h1 className="font-lexend text-2xl leading-8 font-semibold">
              {getTokenErrorTitle(translations, tokenInvalidReason)}
            </h1>
            {tokenErrorDescription && (
              <p className="font-lexend text-sm">{tokenErrorDescription}</p>
            )}
          </div>
        </div>
        <div className="mt-12">
          <Button
            as="a"
            color="primary"
            href={authRoute}
            id="back-to-login"
            variant="ghost"
          >
            {translations.login.linkExpiredBackToLogin}
          </Button>
        </div>
      </div>
    </div>
  );
}
